import React from 'react';
import Modal from 'react-responsive-modal';

import { getCurrentResource } from '../../util/tools';

import iconSpinner from '../../assets/icons/spinner-snake.gif';

export const MODAL_STATE_INIT = 'init'; 
export const MODAL_STATE_POPULATE_INITIAL_DATA = 'populate'; 
export const MODAL_STATE_POPULATE_INITIAL_DATA_ERROR = 'populateError'; 
export const MODAL_STATE_FORM_READY = 'initComplete'; 
export const MODAL_STATE_PERFORM_REQUEST = 'request'; 
export const MODAL_STATE_PERFORM_REQUEST_COMPLETE = 'requestComplete'; 

/*
class X {
	constructor(props) {
		super(props);
		...
		this.refXModalDialog = React.createRef();
		...
	}
	
	openModalDialog = () => {
		this.refXModalDialog.current.openModal();
	}
	
	render() {
		return (
			<React.Fragment>
				...
				<XModalDialog ref={this.refXModalDialog} />
				...
			</React.Fragment>
		)
	}
	
}


class XModalDialog extends ModalDialog {
	constructor(props) {
		super(props);
		this.res = this.props.page.resource;

		this.title=res.modalTitle;
	}
	getStyleModal() {
		let style = super.getStyleModal();
		style.modal.maxWidth = '600px';
		return style;
	}
	async performRequest() {
		let request = {};
		return await performApiRequest(url, request);
	}
	
	renderForm() {
		return (
			<div style={{marginTop: '10px', padding: '10px'}}>
				FORM
			</div>
		)
	}
}
*/

class ModalDialog extends React.Component {

	title = '...';
	buttonOkText = '';
	buttonCancelText = '';
	buttonTryAgainText = '';
	buttonCloseText = '';
	
	populateInitialData = false;
	showOkButton = true;
	showTryAgainButton = true;
	showTryAgainButtonErrorOnly = false;
	populateResponse = null;
	taskResponse = null; 
	
	constructor(props) {
		super(props);
		this.refInfoMessage = React.createRef();
		this.state = {isModalOpen: false};

		let resource = getCurrentResource().components.modal.ModalDialog;		
		this.buttonOkText = resource.buttonOk;
		this.buttonCancelText = resource.buttonCancel;
		this.buttonTryAgainText = resource.buttonTryAgain;
		this.buttonCloseText = resource.buttonClose;
	}
	componentDidMount() {
		if( this.doInit )
			this.init();
	}
	init() {}

	openModal = async () => {
		if( this.populateInitialData ) {
			this.setState({isModalOpen: true, modalState: MODAL_STATE_POPULATE_INITIAL_DATA});
			this.populateResponse = await this.performPopulateInitialData();
			if( this.populateResponse.success )
				this.setState({modalState: MODAL_STATE_FORM_READY});
			else
				this.setState({modalState: MODAL_STATE_POPULATE_INITIAL_DATA_ERROR});
		} else {
			this.setState({isModalOpen: true, modalState: MODAL_STATE_FORM_READY});
		}
	}
	closeModal = () => {
		this.setState({isModalOpen: false}, this.props.doAfterClose);
	}

	tryPerformRequest = async () => {
		this.setState({modalState: MODAL_STATE_PERFORM_REQUEST})
		this.taskResponse = await this.performRequest();
		this.setState({modalState: MODAL_STATE_PERFORM_REQUEST_COMPLETE})
	}
	async performPopulateInitialData() {
		let response = {success: true}
		return response;
	}
	async performRequest() {
		let response = {success: true}
		return response;
	}
	tryAgain = () => {
		this.setState({modalState: MODAL_STATE_FORM_READY})
	}	
	
	getStyleModal() {
		return {
			modal: {
				background: '#ffffff',
				padding: '0px',
				borderRadius: '21px',
				maxWidth: '1200px',
				width: '100%',
			},
			closeButton: {
				top: '10px',
				right: '10px',
				fill: '#FF0000',
				outline: 'none',
			},
		};
	}
	getStyleBody() {
		return {
			divHeader: {
				fontSize: '16pt',
				textAlign: 'center',
				padding: '10px',
				borderRadius: '21px 21px 0 0',
				color: 'blue',
				backgroundColor: '#F0F0F0'
			},
			divForm: {
				marginTop: '10px',
				padding: '10px'
			},
			divWaiting: {
				textAlign: 'center',
				padding: '7px',
				marginBottom: '15px',
			},
			divButtons: {
				marginTop: '7px',
				padding: '10px',
				marginRight: '20px',
				textAlign: 'right'
			}
		};
	}
	
	render() {
		let styleModal = this.getStyleModal();
		if( this.maxWidth )
			styleModal.maxWidth = this.maxWidth; 
		return (
			<Modal 
				open={this.state.isModalOpen} onClose={this.closeModal} center 
				styles={styleModal} closeOnOverlayClick={false} animationDuration={1} 
			>
				{this.renderModalBody()}
			</Modal>
		);
	}
	
	renderModalBody() {
		let resource = getCurrentResource().components.modal.ModalDialog;		
		let modalBodyHtml = null;
		if( this.state.modalState == MODAL_STATE_POPULATE_INITIAL_DATA ) {
			modalBodyHtml = (
				<React.Fragment>
					{this.renderWait()}
				</React.Fragment>
			);
		} else if( this.state.modalState == MODAL_STATE_POPULATE_INITIAL_DATA_ERROR ) {
			let message = this.populateResponse.message;
			if( ! message ) 
				message = resource.msgError;
			let divAdditionalMessage = null;
			if( this.populateResponse.log )
				divAdditionalMessage = (
					<div style={{marginLeft: 'auto', marginRight: 'auto', marginBottom: '30px', width: '95%'}}>
						<textarea style={{width: '100%'}} rows="8" readOnly={true}>
							{this.populateResponse.log}
						</textarea>
					</div>		
				);
			modalBodyHtml = (
				<React.Fragment>
					<div style={{fontSize: '16pt', margin: '10px auto 10px auto', padding: '5px', textAlign: 'center', color: 'red'}} 
						dangerouslySetInnerHTML={{__html: message}} 
					/>
					{divAdditionalMessage}
					{this.renderButtons()}
				</React.Fragment>
			);
		} else if( this.state.modalState == MODAL_STATE_FORM_READY ) {
			modalBodyHtml = (
				<React.Fragment>
					{this.renderForm()}
					{this.renderButtons()}
				</React.Fragment>
			);
		} else if( this.state.modalState == MODAL_STATE_PERFORM_REQUEST ) {
			modalBodyHtml = (
				<React.Fragment>
					{this.renderForm()}
					{this.renderWait()}
				</React.Fragment>
			);
		} else if( this.state.modalState == MODAL_STATE_PERFORM_REQUEST_COMPLETE ) {
			let message = this.taskResponse.message;
			if( ! message ) 
				message = this.taskResponse.success ? resource.msgSuccess : resource.msgError;
			let divAdditionalMessage = null;
			if( this.taskResponse.log )
				divAdditionalMessage = (
					<div style={{marginLeft: 'auto', marginRight: 'auto', marginBottom: '30px', width: '95%'}}>
						<textarea style={{width: '100%'}} rows="8" readOnly={true}>
							{this.taskResponse.log}
						</textarea>
					</div>		
				);
			let msgColor = this.taskResponse.success ? 'blue' : 'red';
			modalBodyHtml = (
				<React.Fragment>
					{this.renderForm()}
					<div style={{fontSize: '16pt', margin: '10px auto 10px auto', padding: '5px', textAlign: 'center', color: msgColor}} 
						dangerouslySetInnerHTML={{__html: message}} 
					/>
					{divAdditionalMessage}
					{this.renderButtons()}
				</React.Fragment>
			);
		}
		return(
			<div>
				{this.renderHeader()}
				{modalBodyHtml}
			</div>
		);
	}
	renderHeader() {
		let styleBody = this.getStyleBody(); 
		return(
			<div style={styleBody.divHeader}>
				{this.title}
			</div>
		);
	}
	renderForm() {
		return null;
	}
	renderWait() {
		let resource = getCurrentResource().components.modal.ModalDialog;		
		let styleBody = this.getStyleBody(); 
		return (
			<div style={styleBody.divWaiting}>
				<div>
					<img src={iconSpinner}/>
				</div>
				<div style={{marginTop: '20px'}}>
					{resource.msgWait}					
				</div>
			</div>
		);
	}
	renderButtons() {
		let styleBody = this.getStyleBody(); 
		if( this.state.modalState == MODAL_STATE_FORM_READY ) {
			let buttonOkHtml = null;
			if( this.showOkButton ) {
				buttonOkHtml = (
					<button type='button' style={{padding: '5px 20px 5px 20px'}} 
						onClick={this.tryPerformRequest}
					>
						{this.buttonOkText}
					</button>
				);
			}
			return (
				<div style={styleBody.divButtons}>
					{buttonOkHtml}
					<button type='button' style={{marginLeft: '20px', padding: '5px 20px 5px 20px'}} 
						onClick={this.closeModal}
					>
						{this.buttonCancelText}
					</button>
				</div>
			);
		}
		if( this.state.modalState == MODAL_STATE_PERFORM_REQUEST_COMPLETE ) {
			let buttonTryAgainHtml = null;
			if( this.showTryAgainButton ) {
				let show = true;
				if( this.showTryAgainButtonErrorOnly ) {
					if( this.taskResponse.success )
						show = false;
				}
				if( show ) {
					buttonTryAgainHtml = (
						<button type='button' style={{padding: '5px 20px 5px 20px'}} 
							onClick={this.tryAgain}
						>
							{this.buttonTryAgainText}
						</button>
					); 
				}
			}
			return (
				<div style={styleBody.divButtons}>
					{buttonTryAgainHtml}
					<button type='button' style={{marginLeft: '20px', padding: '5px 20px 5px 20px'}} 
						onClick={this.closeModal}
					>
						{this.buttonCloseText}
					</button>
				</div>
			);
		}
		if( this.state.modalState == MODAL_STATE_POPULATE_INITIAL_DATA_ERROR ) {
			return (
				<div style={styleBody.divButtons}>
					<button type='button' style={{marginLeft: '20px', padding: '5px 20px 5px 20px'}} 
						onClick={this.closeModal}
					>
						{this.buttonCloseText}
					</button>
				</div>
			);
		}
	}
	
}

export default ModalDialog;
